<script setup lang="ts">
import Container                    from "@ViewCommonComponents/Container.vue";
import type { TypeFooterDataItems } from "@ViewPages/Main/Components/commonTypes";
import ConsultationForm             from "@ViewPages/Main/Components/Common/ConsultationForm.vue";

defineProps<TypeFooterDataItems>();

const formClasses = [
    'footer__top-form',
    'flex max-md:flex-col justify-start lg:justify-end flex-wrap xl:flex-nowrap',
    'max-md:gap-y-3.5 md:gap-x-6 md:gap-y-4'
].join(' ');
</script>

<template>
    <Container>
        <div class="footer__top flex max-lg:flex-col lg:justify-between max-lg:gap-y-11 lg:gap-x-4">
            <div class="footer__item lg:max-w-32%">
                <div class="mb-45px xl:mb-9"
                    v-html="top_data?.logo_img_tag ?? ''"></div>

                <div>
                    {{ __('footer_top_logo_description') }}
                </div>
            </div>

            <div class="footer__item">
                <ConsultationForm :form-classes="formClasses"></ConsultationForm>
            </div>
        </div>
    </Container>
</template>

<style scoped>

</style>
